import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()

/**
 * sevrice to handle behaviour services
 */
export class RoutebehaviourService {

    // to handle the route change
    changeRoute: BehaviorSubject<number> = new BehaviorSubject(1);

    // to handle the content type change
    changeContentType: BehaviorSubject<number> = new BehaviorSubject(1);

    // to hanlde the route change on save data
    changeOnSaveRoute: BehaviorSubject<number> = new BehaviorSubject(1);

    parentChangedSubject: BehaviorSubject<number> = new BehaviorSubject(1);

    changeSaveButton: BehaviorSubject<boolean> = new BehaviorSubject(false);

    loadedEditor: BehaviorSubject<boolean> = new BehaviorSubject(false);

    loadExactSidebar: BehaviorSubject<any> = new BehaviorSubject(1);
}
